import { Props } from "./DeactivateIcon.Parts";

/** Circle with a diagonal bar, from the DLS 4.0 "deactivate icon". */
export const DeactivateIcon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      transform="rotate(-45 10 10)"
      d="M1 10C1 10.55 1.45 11 2 11H18C18.55 11 19 10.55 19 10C19 9.45 18.55 9 18 9H2C1.45 9 1 9.45 1 10ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
      fill="currentColor"
    />
  </svg>
);
